import React, { Component } from 'react';
import { connect } from 'react-redux';

// Externals
import PropTypes from 'prop-types';
import compose from 'recompose/compose';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

// Material components
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';

// Shared layouts
import DashboardLayout from 'layouts/Dashboard';

// Translations
import translate from 'helpers/translate';

// Shared components
import Portlet from 'components/Portlet';

// Shared services
import { fetchAllUsers } from '../../store/user/actionsCreator';

// Custom components
import AllUsersToolbar from './components/AllUsersToolbar';
import AllUsersTable from './components/AllUsersTable';

// Component styles
import styles from './style';

class AllUserList extends Component {
  signal = true;

  state = {
    openAddUserDialog: false,
    limit: 10,
    users: [],
    selectedUsers: [],
    error: null
  };

  componentDidMount() {
    this.signal = true;
    this.props.fetchAllUsers();
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.currentOrganization !== prevProps.currentOrganization) {
      this.props.fetchAllUsers();
    }
  }

  componentWillUnmount() {
    this.signal = false;
  }

  handleSelect = selectedUsers => {
    this.setState({ selectedUsers });
  };

  handleFilterChange = event => {
    this.setState({
      filter: event.target.value
    });
  };

  getFilteredUsers = () => {
    const { users } = this.props;
    const { filter } = this.state;
    if (!filter) {
      return users;
    }

    const lowerFilter = filter.toLowerCase();

    return users.filter(u => {
      return u.name.toLowerCase().indexOf(lowerFilter) >= 0 || u.firstname.toLowerCase().indexOf(lowerFilter) >= 0 || u.email.toLowerCase().indexOf(lowerFilter) >= 0;
    });
  };

  renderUsers() {
    const { classes, isLoading, users, error, strings } = this.props;

    if (isLoading) {
      return (
        <Portlet className={classes.root}>
          <div className={classes.progressWrapper}>
            <CircularProgress />
          </div>
        </Portlet>
      );
    }

    if (error) {
      return (
        <Portlet className={classes.root}>
          <div className={classes.textWrapper}>
            <Typography variant="h6">{error}</Typography>
          </div>
        </Portlet>
      );
    }

    if (users.length === 0) {
      return (
        <Portlet className={classes.root}>
          <div className={classes.textWrapper}>
            <Typography variant="h6">{strings.nothing}</Typography>
          </div>
        </Portlet>
      );
    }

    return (
      <AllUsersTable
        onSelect={this.handleSelect}
        users={this.getFilteredUsers()}
      />
    );
  }

  render() {
    const { classes, strings } = this.props;
    const { selectedUsers } = this.state;

    return (
      <DashboardLayout title={strings.title}>
        <div className={classes.root}>
          <AllUsersToolbar onFilterChange={this.handleFilterChange} onSelect={this.handleSelect} openAddUserDialog={this.openAddUserDialog} selectedUsers={selectedUsers} />
          <div className={classes.content}>{this.renderUsers()}</div>
        </div>
      </DashboardLayout>
    );
  }

  openAddUserDialog = () => {
    this.setState({ openAddUserDialog: true });
  };

  closeAddUserDialog = () => {
    this.setState({ openAddUserDialog: false });
  };
}

AllUserList.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  strings: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    currentOrganization: state.organization.currentOrganization,
    isLoading: state.user.loading,
    users: state.user.users
  };
};

const mapDispatchToProps = {
  fetchAllUsers
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  translate('AllUserList'),
  withStyles(styles)
)(AllUserList);
